import React from 'react';
import { FeatureFlag } from 'react-launch-darkly';
import moment from 'moment';
import classNames from 'classnames';


const ReceiptDetailsHeaderV1 = ({flightStart, flightEnd, pageIconClass, title, hideDates}) => {
    const startDate = moment(flightStart).format('M-D-YY');
    const endDate = moment(flightEnd).format('M-D-YY');
    const dates = hideDates ? null : (
        <div className="receipt-dates">
            <div className="date">
                <div className="date-title">Start Date</div>
                <div>{startDate}</div>
            </div>
            <div className="date">
                <div className="date-title">End Date</div>
                <div>{endDate}</div>
            </div>
        </div>
    );

    return (
        <div className="verify-receipt-details-header">
            <div className="receipt-title">
                <div className={classNames('title-icon', pageIconClass)} />
                <div className="title-text">{title}</div>
            </div>
            {dates}
        </div>
    );
};

const ReceiptDetailsHeaderV2 = ({flightStart, flightEnd, brandName, pageIconClass, title, hideDates}) => {
    const startDate = moment(flightStart).format('M-D-YY');
    const endDate = moment(flightEnd).format('M-D-YY');
    
    const dates = hideDates ? null : (
        <div className="receipt-detail">
            <div className="detail">
                <p className="title">Start Date</p>
                <p>{startDate}</p>
            </div>
            <div className="detail">
                <p className="title">End Date</p>
                <p>{endDate}</p>
            </div>
        </div>
    );

    return (
        <div className="verify-receipt-details-header-full-width">
            <div className="receipt-title">
                <div className={classNames('icon', pageIconClass)} />
                <h3 className="title">{title}</h3>
            </div>

            <div className="receipt-detail-container">
                <div className="receipt-detail receipt-brand">
                    <div className="detail">
                        <p className="title">Brand</p>
                        <p>{brandName}</p>
                    </div>
                </div>
                {dates}
            </div>
        </div>
    );
};

const ReceiptDetailsHeader = (props) => (
    <FeatureFlag
        flagKey="order-form-v2-enabled"
        renderFeatureCallback={(flag) =>
            flag
                ? <ReceiptDetailsHeaderV2 {...props} />
                : <ReceiptDetailsHeaderV1 {...props} />
        }
        renderDefaultCallback={() => <ReceiptDetailsHeaderV1 {...props} />}
    />
);

export default ReceiptDetailsHeader;


        


// WEBPACK FOOTER //
// ./campaign_launch/verify_receipt/verify_receipt_details/receipt_details_header.js